module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-store-item",
    on: {
      "click": _vm.activate
    }
  }, [_c('span', {
    staticClass: "store-item-select tofu-icon icon-check",
    class: {
      'space': _vm.tab.id !== _vm.activeId
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "store-item-label"
  }, [_vm._v(_vm._s(_vm.tab.label))]), _vm._v(" "), (!_vm.tab.fixed) ? _c('span', {
    staticClass: "store-item-close tofu-icon icon-close",
    on: {
      "click": _vm.destroy
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7e98b02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/new-tabbar/src/tab-store-item.vue
// module id = 679
// module chunks = 0